import React from "react";
import {Button, Modal} from "react-bootstrap";
import CreateForm from "./delegates/create-delegate-form.jsx";
import CreateSummary from "./delegates/create-summary-form.jsx";
import DelegateList from "./delegates/delegate-list.jsx";
import ajax from "./../lib/ajax.js";
import context from "./../lib/context.js";
import moment from "moment";
import immutable from "immutable";

export default class Delegates extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            delegateList: [],
            createObj: {
                domain: '',
                username: '',
                startDate: null,
                endDate: null
            },
            summaryObj: null,
            showSummary: false
        }

        this.onCreate = this.onCreate.bind(this);
        this.loadDelegateList = this.loadDelegateList.bind(this);
    }

    componentDidMount() {
        context.message({
            show: true,
            type: "loading",
            message: "Loading. Please wait..."
        });
        this.loadDelegateList();
    }

    onCreate(newDelegate) {
        console.log(newDelegate);
        this.setState(
            {
                summaryObj: newDelegate, 
                showSummary: true, 
                createObj: {domain: '', username: '', startDate: null, endDate: null}
            }, 
            this.loadDelegateList()
        );
    }

    loadDelegateList() {
        let self = this;                
        let vm = self.state;        
        context.message({show:true, type: "loading", message:"Loading. Please wait..."});
        ajax.api().get("supervisor/get-delegates")
            .then(function(res) {
                self.setState({delegateList: res.data});
                context.message({show:false});
            })
            .catch(function(err) {
                let data = err.response.data;
                context.message({
                    show: true,
                    type: "error",
                    message: data.exceptionMessage || data.message,
                    buttons: "close"
                });
            });
    }

    render() {
        const self = this;
        return (
            <div className="container">
                <div className="row hidden-sm hidden-xs">
                    <div className="col-md-12">
                        <h2 className="text-center ap-title">Add Timecard Delegate</h2>
                    </div>
                </div>
                <div className="row hidden-sm hidden-xs">
                    <div className="col-md-12">
                        A &quot;Delegate&quot; is a person you have chosen to approve timecards on your behalf. Use this screen to choose a delegate for a specific time period. Your delegate will be able to approve timecards only for the specific time period you select. After the time period expires, they will no longer be able to approve timecards for you. You may choose more than one delegate.
                    </div>
                </div>
                <div className="row hidden-sm hidden-xs">
                    <div className="col-md-12">
                        <h3>Information about your delegate</h3>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <CreateForm vm={self.state.createObj} onSave={this.onCreate} />
                    </div>
                </div>
                <hr />
                <div className="row">
                    <div className="col-md-12">
                        <DelegateList vm={self.state.delegateList} />
                    </div>
                </div>


                <Modal bsSize="large" show={this.state.showSummary} onHide={() => this.setState({showSummary: false})}>
                    <Modal.Header closeButton={true}>
                        <Modal.Title>Delegate Added Successfully</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <CreateSummary vm={self.state.summaryObj} />
                    </Modal.Body>
                
                    <Modal.Footer>
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-md-4"></div>
                                <div className="col-md-4"></div>
                                <div className="col-md-4">
                                    <Button className="ap-fullsize" onClick={() => this.setState({showSummary: false})}>Close</Button>                                 
                                </div>
                            </div>
                        </div>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}